<template>
  <div class="EventsDataTable-container Content clearfix">
    <div>
      <div
        class="Filter-container u-floatRight u-flex"
      >
        <div class="SearchInputGroup" />
      </div>
      <div class="">
        <div
          v-if="loadingState"
          class="js-loading"
        />

        <place-holder
          v-if="ui.showPlaceHolder"
          :search="additionalParams.search"
          lang-key="deliveries"
        />
        <div
          :class="['DataTable',{'DataTable--hide': ui.showPlaceHolder}]"
        >
          <vuetable-pagination-info
            ref="paginationInfo"
            :css="paginationInfoConfig.css"
            :info-template="table.paginationInfoConfig.infoTemplate"
          />
          <vue-table
            ref="vuetable"
            :api-mode="true"
            :api-url="table.options.apiUrl"
            :fields="table.options.columns"
            :append-params="additionalParams"
            :css="tableConfig.css"
            :per-page="tableConfig.perPage"
            :sort-order="table.options.sortOrder"
            pagination-path=""
            @vuetable:loading="loadingState = true"
            @vuetable:loaded="setTableStatus"
            @vuetable:load-error="handleDataTableError"
            @vuetable:pagination-data="handleDataTableLoaded"
          >
            <div
              slot="deliveredAt"
              slot-scope="props"
              style="cursor:pointer"
              @click="handleViewDelivery(props.rowData)"
            >
              <span class="Hint">
                {{ props.rowData.deliveredAt }}
              </span>
              <!-- <p>{{ integration.name }}</p> -->
              <a
                v-if="props.rowData.urlToViewResponse !== null"
                class="ViewRecordLink"
                target="_blank"
                @click.stop="viewWebFormRecord(props.rowData.urlToViewResponse)"
              >View Web Form Record</a>
              <span class="Hint">
                Delivery identifier: {{ props.rowData.uuid }}
              </span>
              <span
                v-if="props.rowData.integrationAgent==='zapier'"
                class="Hint"
              >
                Manually delivered: {{ props.rowData.isRedeliver?'yes':'no' }}
              </span>
            </div>
            <div
              slot="wasDeliveredWithSuccess"
              slot-scope="props"
              class="Name"
            >
              <span
                v-if="props.rowData.wasDeliveredWithSuccess"
                class="Icon-s Icon-check-circle"
              />
              <span
                v-else
                class="Icon-s Icon-exclamation-circle"
              />
            </div>
            <div
              slot="updated_at"
              slot-scope="props"
              class="Name"
            >
              <p class="template">
                {{ props.rowData.updated_at }}
              </p>
            </div>
          </vue-table>
          <vuetable-pagination
            ref="pagination"
            class="u-floatRight"
            :css="paginationConfig.css"
            @vuetable-pagination:change-page="onChangePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@rmpenterprise/form-autocomplete-select/dist/autocomplete-select.esm.css';
import PlaceHolder from '../common/no-data-placeholder.vue';
import DataTableMixin from '../../../mixins/datatable-mixin';

export default {
  components: {
    'place-holder': PlaceHolder,
  },
  mixins: [DataTableMixin],
  props: {
    eventId: {
      type: Number,
      default: null,
    },
    integration: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loadingState: false,
      selectedEvent: null,
      showDeliveryDetails: false,
      selectedDelivery: null,
      tab: 'request',
      ui: {
        hideFilters: false,
        loading: false,
      },
      model: {
        filter: null,
      },
      table: {
        paginationInfoConfig: {
          infoTemplate: '{from} - {to} of {total} Deliveries',
          css: {
            infoClass: 'view-all',
          },
        },
        options: {
          sortOrder: [
            {
              field: 'start_date',
              direction: 'desc',
            },
          ],
          apiUrl: `/ajax/web-forms/events/${this.eventId}/integrations/${this.integration.id}`,
          columns: [
            {
              name: 'deliveredAt',
              title: 'Deliveries',
            },
            {
              name: 'wasDeliveredWithSuccess',
              title: '',
            },
          ],
        },
      },
    };
  },
  methods: {
    handleViewDelivery(delivery) {
      this.$emit('integration-deliveries:show', delivery);
    },
    viewWebFormRecord(link) {
      window.open(link, '_blank').focus();
    },
    handleDataTableLoaded(data) {
      this.onPaginationData(data);
    },
  },
};
</script>

<style scoped lang="less">

  .Name {
    p {
      margin: 0;
    }
    .list {
      color: #909090;
    }
  }

  .vuetable-pagination-info.right {
    margin-top: 10px;
    margin-right: 10px;
    float: left;
  }

  .ViewRecordLink {
    display: inline-block;
    margin: 5px 0;

    &:hover {
      text-decoration: underline;
    }
  }

  .Hint {
    display: block;
  }

  .Icon-exclamation-circle {
      color: #FF0000;
  }
  .Icon-check-circle {
    color: #39B546;
  }
  .NotVisible {
    background: grey;
  }
</style>
